import React, { Component } from "react";
import { connect } from "react-redux";

import { setConnectionFlag } from "state/modules/network";
import { getDemographics } from "state/modules/app";
import { getSurveyQuestionnaire } from "screens/question/selectors";

// TODO: Convert to middleware
class BaseNetworkListener extends Component {
  state = { fingerprintDone: false };

  componentDidMount = () => {
    window.addEventListener("online", () => {
      this.props.setConnectionFlag(true);
    });
    window.addEventListener("offline", () => {
      this.props.setConnectionFlag(false);
    });
  };

  componentDidUpdate = prevProps => {
    if (
      !this.state.fingerprintDone &&
      !this.props.questionnaire?.config?.disable_fingerprinting &&
      prevProps.questionnaire?.id !== this.props.questionnaire?.id
    ) {
      this.props.getDemographics();
      this.setState({ fingerprintDone: true });
    }
  };

  render = () => <></>;
}

const mapStateToProps = state => {
  return {
    questionnaire: getSurveyQuestionnaire(state),
  };
};

const mapDispatchToProps = {
  setConnectionFlag,
  getDemographics,
};

export const NetworkListener = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BaseNetworkListener);
